// src/design-system/tone.ts
export type Tone = "gold" | "ok" | "warn" | "bad" | "mute" | "info" | "violet";

export const TONE_FG: Record<Tone, string> = {
  gold: "#F0CE8A", ok: "#6FD39A", warn: "#E8C06A", bad: "#F0736A", mute: "#9FB4C9", info: "#8FC4F0", violet: "#B79CE8",
};
